import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular/lazy';
import { TranslationService } from 'src/app/services/i18n/translation.service';

@Component({
  selector: 'app-modale-consenso-privacy',
  templateUrl: './modale-consenso-privacy.page.html',
  styleUrls: ['./modale-consenso-privacy.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModaleConsensoPrivacyPage {
  translation = inject(TranslationService);

  consentForm = new FormGroup({
    checkboxPrivacy1: new FormControl(false, [Validators.requiredTrue]),
    checkboxPrivacy2: new FormControl(false, [Validators.requiredTrue])
  });

  constructor(private modalCtrl: ModalController) { }

  accept() {
    if (this.consentForm.invalid) return;
    this.modalCtrl.dismiss({ accepted: true });
  }

  cancel() {
    this.modalCtrl.dismiss({ accepted: false });
  }
}
